import type React from "react";

import styled from "styled-components";

const Container = styled.div<{
  $bgColor?: string;
  $color?: string;
  $borderColor?: string;
  $uppercase?: boolean;
  $noMargin?: boolean;
}>`
  display: flex;
  justify-content: center;
  line-height: 16px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: ${props => props.$uppercase && "uppercase"};
  padding: 4px 8px;
  margin-right: ${props => (props.$noMargin ? "0" : props.theme.spacing.S_5)};
  border: 1px solid ${props => (props.$borderColor ? props.$borderColor : "transparent")};
  background-color: ${props => (props.$bgColor ? props.$bgColor : props.theme.colors.redesign.b10)};
  color: ${props => (props.$color ? props.$color : props.theme.colors.redesign.b100)};
`;

interface Props {
  readonly label: string;
  readonly bgColor?: string;
  readonly color?: string;
  readonly borderColor?: string;
  readonly className?: string;
  readonly dataTestId?: string;
  readonly uppercase?: boolean;
  readonly noMargin?: boolean;
}

export const Tag: React.FC<Props> = ({
  label,
  bgColor,
  color,
  borderColor,
  className,
  dataTestId = "",
  uppercase,
  noMargin,
}) => {
  return (
    <Container
      $bgColor={bgColor}
      $color={color}
      $borderColor={borderColor}
      className={className}
      data-testid={dataTestId}
      $uppercase={uppercase}
      $noMargin={noMargin}
    >
      {label}
    </Container>
  );
};
